import React, { useState, useEffect } from 'react';
import axios from 'axios';

const CashierPage = () => {
  const [carts, setCarts] = useState([]);
  const [selectedCart, setSelectedCart] = useState(null);
  const [cashierPin, setCashierPin] = useState('');
  const [transactionType, setTransactionType] = useState('cash');
  const [amountPaid, setAmountPaid] = useState(0);
  const [change, setChange] = useState(0);
  const [seniorDiscount, setSeniorDiscount] = useState(false);
  const [promoDiscount, setPromoDiscount] = useState(0);
  const [VAT, setVAT] = useState(0);
  const [isPinValid, setIsPinValid] = useState(false);
  const [isShiftActive, setIsShiftActive] = useState(false); // New State for Shift
  const [shiftId, setShiftId] = useState(null);


  const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:5001';

  // Fetch active carts
  useEffect(() => {
    const fetchCarts = async () => {
      try {
        const response = await axios.get(`${apiUrl}/api/carts/open`);
        setCarts(response.data);
      } catch (error) {
        console.error('Error fetching carts:', error);
      }
    };
    fetchCarts();
  }, [apiUrl]);

  // Fetch shift status
  useEffect(() => {
    const fetchShiftStatus = async () => {
      try {
        const response = await axios.get(`${apiUrl}/api/shift/status`);
        if (response.data.active) {
          setIsShiftActive(true);
          setShiftId(response.data.shiftId);
        }
      } catch (error) {
        console.error('Error fetching shift status:', error);
      }
    };
    fetchShiftStatus();
  }, [apiUrl]);

  // Handle Start Shift
  const handleStartShift = async () => {
    try {
      const response = await axios.post(`${apiUrl}/api/shift/start`, { cashierPin });
      if (response.data.success) {
        setIsShiftActive(true);
        setShiftId(response.data.shiftId);
        alert('Shift started successfully');
      } else {
        alert('Failed to start shift');
      }
    } catch (error) {
      console.error('Error starting shift:', error);
    }
  };

  // Handle End Shift
  const handleEndShift = async () => {
    try {
      const response = await axios.post(`${apiUrl}/api/shift/end`, { shiftId });
      if (response.data.success) {
        setIsShiftActive(false);
        setShiftId(null);
        alert('Shift ended successfully');
      } else {
        alert('Failed to end shift');
      }
    } catch (error) {
      console.error('Error ending shift:', error);
    }
  };

  // Select cart for billing
  const handleSelectCart = (cart) => {
    setSelectedCart(cart);
    const calculatedTotal = cart.items.reduce((acc, item) => acc + item.price * item.quantity, 0);
    setVAT(calculatedTotal * 0.12); // Assume 12% VAT
  };

  // Validate PIN
  const verifyCashierPin = async () => {
    try {
      const response = await axios.post(`${apiUrl}/api/users/verifyCashierPin`, {
        cashierPin,
      });
      if (response.status === 200) {
        setIsPinValid(true);
        alert('PIN verified successfully');
      } else {
        alert('Invalid PIN');
      }
    } catch (error) {
      console.error('Error verifying PIN:', error);
    }
  };

  // Process payment
  const handlePayment = async () => {
    if (!selectedCart) {
      alert('Please select an order to process.');
      return;
    }

    const totalAmount = selectedCart.items.reduce(
      (acc, item) => acc + item.price * item.quantity,
      0
    );
    const discountedAmount = seniorDiscount ? totalAmount * 0.8 : totalAmount; // Example senior discount
    const finalAmount = discountedAmount + VAT - promoDiscount;

    if (transactionType === 'cash' && amountPaid < finalAmount) {
      alert('Insufficient payment.');
      return;
    }

    setChange(amountPaid - finalAmount);

    try {
      await axios.post(`${apiUrl}/api/carts/bill-out`, {
        cartId: selectedCart._id,
        transactionType,
        cashierPin,
        amountPaid,
        change: amountPaid - finalAmount,
        VAT,
        promoDiscount,
        seniorDiscount,
      });
      alert('Payment processed successfully.');
      setSelectedCart(null);
    } catch (error) {
      console.error('Error processing payment:', error);
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Cashier Module</h1>

      {/* Shift Management */}
      <div className="mb-4">
        {!isShiftActive ? (
          <button
            onClick={handleStartShift}
            className="bg-green-500 text-white p-2 rounded"
          >
            Start Shift
          </button>
        ) : (
          <button
            onClick={handleEndShift}
            className="bg-red-500 text-white p-2 rounded"
          >
            End Shift
          </button>
        )}
      </div>

      {/* Active Orders */}
      <div className="mb-6">
        <h2 className="text-lg font-semibold mb-2">Active Orders</h2>
        <ul className="border rounded p-4">
          {carts.map((cart) => (
            <li
              key={cart._id}
              className={`p-2 cursor-pointer hover:bg-gray-100 ${
                selectedCart?._id === cart._id ? 'bg-blue-100' : ''
              }`}
              onClick={() => handleSelectCart(cart)}
            >
              Table: {cart.tableNumber}, Waiter: {cart.waiter}
            </li>
          ))}
        </ul>
      </div>

      {/* Payment Section */}
      {/* ... */}
    </div>
  );
};

export default CashierPage;
